export enum steps {
  Photo = 'photo',
  Form = 'Form',
  Verify = 'Verify',
}

export enum ShfitFunction {
  Start = 'Start',
  End = 'End',
}